import { css } from 'lit';
export const tooltipStyle = css `
  :host {
    display: flex;
    padding: 4px;
    color: var(--color-content-content-primary);
    background: var(--color-background-bg-primary);
    font-size: 14px;
  }
`;
//# sourceMappingURL=tooltip.style.js.map